import React from "react";
import PropTypes from "prop-types";
import Styles from "./Styles";

const SearchArea = ({ title, depth, leftExtra, rightExtra }) => {
  const returnDepth = () => {
    switch (depth) {
      case "depth2":
        return <h2 className='page-tit-2'>{title}</h2>;
      case "depth3":
        return <h3 className='page-tit-3'>{title}</h3>;
      default:
        return <h1 className='page-tit-1'>{title}</h1>;
    }
  };

  return (
    <Styles className={title ? "search-area has-tit" : "search-area"}>
      <div className='extra-area left'>
        {returnDepth()}
        {leftExtra}
      </div>
      {rightExtra && <div className='extra-area right'>{rightExtra}</div>}
    </Styles>
  );
};

SearchArea.propTypes = {
  title: PropTypes.string,
  depth: PropTypes.string,
};

SearchArea.defaultProps = {
  title: null,
  depth: "depth1",
};

export default SearchArea;
